import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "users-list" }
const _hoisted_2 = { class: "my-2 grid grid-cols-1 gap-y-4" }
const _hoisted_3 = { class: "mb-2 flex items-center gap-3" }
const _hoisted_4 = { class: "flex h-11 w-11 items-center justify-center rounded-xl bg-slate-100 text-slate-700" }
const _hoisted_5 = { class: "form" }
const _hoisted_6 = { class: "setting-field-wrap" }
const _hoisted_7 = { class: "setting-field-wrap" }
const _hoisted_8 = { class: "setting-field-wrap" }
const _hoisted_9 = { class: "setting-field-wrap" }
const _hoisted_10 = { class: "setting-field-wrap" }
const _hoisted_11 = { class: "setting-field-wrap" }
const _hoisted_12 = { class: "setting-field-wrap" }
const _hoisted_13 = { class: "setting-field-wrap" }
const _hoisted_14 = { class: "setting-field-wrap" }
const _hoisted_15 = { class: "setting-field-wrap" }
const _hoisted_16 = { class: "setting-field-wrap" }
const _hoisted_17 = { class: "setting-field-wrap" }
const _hoisted_18 = { class: "setting-field-wrap" }
const _hoisted_19 = { class: "setting-field-wrap" }
const _hoisted_20 = { class: "setting-field-wrap" }
const _hoisted_21 = { class: "setting-field-wrap" }
const _hoisted_22 = { class: "w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_custom_button = _resolveComponent("custom-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("header", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, [
            _createVNode(_component_v_icon, { size: "22" }, {
              default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                _createTextVNode("mdi-tune-variant", -1)
              ]))]),
              _: 1
            })
          ]),
          _cache[18] || (_cache[18] = _createElementVNode("div", null, [
            _createElementVNode("h1", { class: "text-xl font-bold text-slate-900" }, "تنظیمات کلی سیستم"),
            _createElementVNode("p", { class: "mt-1 text-sm text-slate-500" }, "مقادیر کارمزد و محدودیت‌های شارژ و برداشت را مدیریت کنید.")
          ], -1))
        ]),
        _createElementVNode("form", {
          onSubmit: _cache[16] || (_cache[16] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitSettingsFilter && _ctx.submitSettingsFilter(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[19] || (_cache[19] = _createElementVNode("label", {
                class: "setting-field-label",
                for: "transfer-fixed-riali"
              }, "کارمزد ثابت انتقال ریالی", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "transfer-fixed-riali",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.getSystemSettings.Transfer_fixedFeeRiali) = $event)),
                class: "setting-field",
                type: "number",
                inputmode: "decimal"
              }, null, 512), [
                [_vModelText, _ctx.getSystemSettings.Transfer_fixedFeeRiali]
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[20] || (_cache[20] = _createElementVNode("label", {
                class: "setting-field-label",
                for: "transfer-fixed-usdt"
              }, "کارمزد ثابت انتقال تتری", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "transfer-fixed-usdt",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.getSystemSettings.Transfer_fixedFeeUsdt) = $event)),
                class: "setting-field",
                type: "number",
                inputmode: "decimal"
              }, null, 512), [
                [_vModelText, _ctx.getSystemSettings.Transfer_fixedFeeUsdt]
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[21] || (_cache[21] = _createElementVNode("label", {
                class: "setting-field-label",
                for: "transfer-percent-riali"
              }, "کارمزد درصدی انتقال ریالی", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "transfer-percent-riali",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.getSystemSettings.Transfer_percentageFeeRiali) = $event)),
                class: "setting-field",
                type: "number",
                inputmode: "decimal"
              }, null, 512), [
                [_vModelText, _ctx.getSystemSettings.Transfer_percentageFeeRiali]
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[22] || (_cache[22] = _createElementVNode("label", {
                class: "setting-field-label",
                for: "transfer-percent-usdt"
              }, "کارمزد درصدی انتقال تتری", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "transfer-percent-usdt",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.getSystemSettings.Transfer_percentageFeeUsdt) = $event)),
                class: "setting-field",
                type: "number",
                inputmode: "decimal"
              }, null, 512), [
                [_vModelText, _ctx.getSystemSettings.Transfer_percentageFeeUsdt]
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _cache[23] || (_cache[23] = _createElementVNode("label", {
                class: "setting-field-label",
                for: "charge-max-riali"
              }, "حداکثر شارژ ریالی", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "charge-max-riali",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.getSystemSettings.charge_maximumRiali) = $event)),
                class: "setting-field",
                type: "number",
                inputmode: "decimal"
              }, null, 512), [
                [_vModelText, _ctx.getSystemSettings.charge_maximumRiali]
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _cache[24] || (_cache[24] = _createElementVNode("label", {
                class: "setting-field-label",
                for: "charge-min-riali"
              }, "حداقل شارژ ریالی", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "charge-min-riali",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.getSystemSettings.charge_minimumRiali) = $event)),
                class: "setting-field",
                type: "number",
                inputmode: "decimal"
              }, null, 512), [
                [_vModelText, _ctx.getSystemSettings.charge_minimumRiali]
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _cache[25] || (_cache[25] = _createElementVNode("label", {
                class: "setting-field-label",
                for: "charge-min-crypto"
              }, "حداقل شارژ کریپتو", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "charge-min-crypto",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.getSystemSettings.charge_minimumCrypto) = $event)),
                class: "setting-field",
                type: "number",
                inputmode: "decimal"
              }, null, 512), [
                [_vModelText, _ctx.getSystemSettings.charge_minimumCrypto]
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _cache[26] || (_cache[26] = _createElementVNode("label", {
                class: "setting-field-label",
                for: "commission-gateway"
              }, "کارمزد درگاه", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "commission-gateway",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.getSystemSettings.commissionGateway) = $event)),
                class: "setting-field",
                type: "number",
                inputmode: "decimal"
              }, null, 512), [
                [_vModelText, _ctx.getSystemSettings.commissionGateway]
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _cache[27] || (_cache[27] = _createElementVNode("label", {
                class: "setting-field-label",
                for: "withdraw-fixed-riali"
              }, "کارمزد ثابت برداشت ریالی", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "withdraw-fixed-riali",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.getSystemSettings.withdraw_fixedFeeRiali) = $event)),
                class: "setting-field",
                type: "number",
                inputmode: "decimal"
              }, null, 512), [
                [_vModelText, _ctx.getSystemSettings.withdraw_fixedFeeRiali]
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _cache[28] || (_cache[28] = _createElementVNode("label", {
                class: "setting-field-label",
                for: "withdraw-fixed-usdt"
              }, "کارمزد ثابت برداشت تتری", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "withdraw-fixed-usdt",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.getSystemSettings.withdraw_fixedFeeUsdt) = $event)),
                class: "setting-field",
                type: "number",
                inputmode: "decimal"
              }, null, 512), [
                [_vModelText, _ctx.getSystemSettings.withdraw_fixedFeeUsdt]
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _cache[29] || (_cache[29] = _createElementVNode("label", {
                class: "setting-field-label",
                for: "withdraw-max-riali"
              }, "حداکثر برداشت ریالی", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "withdraw-max-riali",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.getSystemSettings.withdraw_maximumRiali) = $event)),
                class: "setting-field",
                type: "number",
                inputmode: "decimal"
              }, null, 512), [
                [_vModelText, _ctx.getSystemSettings.withdraw_maximumRiali]
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _cache[30] || (_cache[30] = _createElementVNode("label", {
                class: "setting-field-label",
                for: "withdraw-min-riali"
              }, "حداقل برداشت ریالی", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "withdraw-min-riali",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.getSystemSettings.withdraw_minimumRiali) = $event)),
                class: "setting-field",
                type: "number",
                inputmode: "decimal"
              }, null, 512), [
                [_vModelText, _ctx.getSystemSettings.withdraw_minimumRiali]
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _cache[31] || (_cache[31] = _createElementVNode("label", {
                class: "setting-field-label",
                for: "withdraw-min-usdt"
              }, "حداقل برداشت تتری", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "withdraw-min-usdt",
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.getSystemSettings.withdraw_minimumUsdt) = $event)),
                class: "setting-field",
                type: "number",
                inputmode: "decimal"
              }, null, 512), [
                [_vModelText, _ctx.getSystemSettings.withdraw_minimumUsdt]
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _cache[32] || (_cache[32] = _createElementVNode("label", {
                class: "setting-field-label",
                for: "withdraw-percent-riali"
              }, "کارمزد درصدی برداشت ریالی", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "withdraw-percent-riali",
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.getSystemSettings.withdraw_percentageFeeRiali) = $event)),
                class: "setting-field",
                type: "number",
                inputmode: "decimal"
              }, null, 512), [
                [_vModelText, _ctx.getSystemSettings.withdraw_percentageFeeRiali]
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _cache[33] || (_cache[33] = _createElementVNode("label", {
                class: "setting-field-label",
                for: "withdraw-percent-usdt"
              }, "کارمزد درصدی برداشت تتری", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "withdraw-percent-usdt",
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.getSystemSettings.withdraw_percentageFeeUsdt) = $event)),
                class: "setting-field",
                type: "number",
                inputmode: "decimal"
              }, null, 512), [
                [_vModelText, _ctx.getSystemSettings.withdraw_percentageFeeUsdt]
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _cache[34] || (_cache[34] = _createElementVNode("label", {
                class: "setting-field-label",
                for: "commission-gateway-auth"
              }, "کارمزد ثابت احراز درگاه", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "commission-gateway-auth",
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.getSystemSettings.commissionGatewayAuth) = $event)),
                class: "setting-field",
                type: "number",
                inputmode: "decimal"
              }, null, 512), [
                [_vModelText, _ctx.getSystemSettings.commissionGatewayAuth]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_custom_button, {
              class: "w-full mt-6",
              type: "submit",
              text: "ثبت تنظیمات",
              loading: _ctx.getLoadingPanel
            }, null, 8, ["loading"])
          ])
        ], 32)
      ])
    ])
  ]))
}